import { formatUrl } from 'url-lib';
import { makeCachedResourceTools } from '@eb/resource-cache-tools';
import {
    EVENT_SALES_STATUS_EXPANSION,
    BASIC_INVENTORY_INFO_EXPANSION,
    DISCOUNT_USAGE_COUNTS_EXPANSION,
} from './constants';

const EVENT_API_GET_EXPANSIONS = [
    EVENT_SALES_STATUS_EXPANSION,
    BASIC_INVENTORY_INFO_EXPANSION,
    DISCOUNT_USAGE_COUNTS_EXPANSION,
];

export const eventCache = makeCachedResourceTools(({ eventId }) =>
    formatUrl(`/api/v3/events/${eventId}/`, {
        expand: EVENT_API_GET_EXPANSIONS.join(','),
    }),
);
